<template>
  <div id="app">
    <NowPlaying />
  </div>
</template>

<script>
import NowPlaying from '@/components/NowPlaying.vue'

export default {
  name: 'App',
  components: {
    NowPlaying
  }
}
</script>

<style>
#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>